import { MediaViewer } from '@atlaskit/media-viewer';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import React, { useEffect, useRef } from 'react';

const MediaViewerContainer = props => {
  const {
    mediaItems,
    selectedMediaItem,
    onClose,
    testId
  } = props;
  const MEDIA_ITEM_TYPE = 'external-image';
  const mediaViewerRef = useRef();
  useEffect(() => {
    if (mediaViewerRef.current) disableBodyScroll(mediaViewerRef.current);
    return () => {
      if (mediaViewerRef.current) enableBodyScroll(mediaViewerRef.current);
    };
  }, []); // returns full set of media

  const toMediaItem = media => ({
    mediaItemType: MEDIA_ITEM_TYPE,
    dataURI: media.dataURI,
    name: media.name
  });

  const dataSource = {
    list: mediaItems.map(toMediaItem)
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: mediaViewerRef,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(MediaViewer, {
    selectedItem: toMediaItem(selectedMediaItem),
    dataSource: dataSource,
    onClose: onClose
  }));
};

export default MediaViewerContainer;